import {Navigate, useRoutes} from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import UserPage from './pages/UserPage';
import NominationPage from './pages/NominationPage';
import VotePage from './pages/VotePage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import {VoteForm, VoteResult} from "./sections/@dashboard/vote";
import HomePage from "./pages/HomePage";
import ArchivePage from "./pages/ArchivePage";
import ErrorPage from "./pages/ErrorPage";
import AdminPage from "./pages/AdminPage";

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/dashboard/home" />, index: true },
        { path: 'home', element: <HomePage /> },
        { path: 'user', element: <UserPage /> },
        { path: 'nomination', element: <NominationPage /> },
        {
          path: 'vote',
          element: <VotePage />,
          children: [
            { path: 'form', element: <VoteForm /> },
            { path: 'result', element: <VoteResult /> }
          ]
        },
        { path: 'archives', element: <ArchivePage /> },
        { path: 'admin', element: <AdminPage /> }
      ],
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/home" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: 'error', element: <ErrorPage /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
